import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue-demi';
import { useMagicKeys, onClickOutside } from '@vueuse/core';
import { AbIcon } from '../../ui';
interface Props {
  width?: string;
  closeable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiModal',
  props: {
    width: { default: '700px' },
    closeable: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { width: string, closeable: boolean };



const { escape } = useMagicKeys();
const isOpen = ref(false);

const close = () => {
  if (isOpen.value === false) return;
  isOpen.value = false;
};

const open = () => {
  if (isOpen.value === true) return;
  isOpen.value = true;
};

expose({
  open,
  close,
});

watch(escape, (v) => {
  if (!v) return;
  if (isOpen.value === false) return;
  close();
});

const modal = ref(null);
onClickOutside(modal, () => close());

return { __sfc: true,props, escape, isOpen, close, open, modal, AbIcon }
}

})